export const administratorRole = [
    '/',
    'agreement36',
    'yearlyAgreement36',
    'monthlyAgreement36',
    'attendApplicationApproval',
    'attendStampList',
    'attendApplicationList',
    'attendError',
    'attendHolidayManagement',
    'attendHeadquartersFinal',
    'timeRecalculation',
    'attendAchievementOutput',
    'attendCSVOutput',
    'stampHistory',
    'GpsStampHistory',
    'dailyShift',
    'monthlyShift',
    'organizations',
    'staffs',
    'executive',
    'vacationMaster',
    'masterPaidHolidayPattern',
    'masterTerm',
    'masterWorkingDays',
    'masterWorkingHours',
    'masterEmploymentForm',
    'masterAttendSetting',
    'masterOrganizeSetting',
    'masterSettingAgreement36',
    'masterShiftPattern',
    'masterShopFaceRegistration',
    'masterShopFaceRegistrationV1',
    'masterICCard',
    'masterTimeOutputLayout',
    'masterShopSpecify',
    'masterSettingAgreement36',
    'personalSetting',
    'recorder',
    'logout',
    '404',
    'holiday',
    'monthlyAgreement36',
    'yearlyAgreement36',
];

export const hrRole = [
    '/',
    'agreement36',
    'yearlyAgreement36',
    'monthlyAgreement36',
    'attendApplicationApproval',
    'attendStampList',
    'attendApplicationList',
    'attendError',
    'attendHolidayManagement',
    'attendHeadquartersFinal',
    'timeRecalculation',
    'attendAchievementOutput',
    'attendCSVOutput',
    'stampHistory',
    'GpsStampHistory',
    'dailyShift',
    'monthlyShift',
    'personalSetting',
    'recorder',
    'logout',
    '404',
    'monthlyAgreement36',
    'yearlyAgreement36',
];

export const leadRole = [
    '/',
    'agreement36',
    'yearlyAgreement36',
    'monthlyAgreement36',
    'attendApplicationApproval',
    'attendStampList',
    'attendApplicationList',
    'attendError',
    'attendHolidayManagement',
    'attendCSVOutput',
    'stampHistory',
    'GpsStampHistory',
    'dailyShift',
    'monthlyShift',
    'masterOrganizeSetting',
    'masterShiftPattern',
    'masterShopFaceRegistration',
    'masterShopFaceRegistrationV1',
    'masterICCard',
    'masterShopSpecify',
    'personalSetting',
    'recorder',
    'logout',
    '404',
    'monthlyAgreement36',
    'yearlyAgreement36',
];

export const subLeadRole = [
    '/',
    'agreement36',
    'yearlyAgreement36',
    'monthlyAgreement36',
    'attendApplicationApproval',
    'attendStampList',
    'attendApplicationList',
    'attendError',
    'attendHolidayManagement',
    'attendCSVOutput',
    'stampHistory',
    'GpsStampHistory',
    'dailyShift',
    'monthlyShift',
    'personalSetting',
    'recorder',
    'logout',
    '404',
    'monthlyAgreement36',
    'yearlyAgreement36',
];

export const staffRole = [
    '/',
    'agreement36',
    // 'attendApplicationApproval',
    'attendStampList',
    'attendApplicationList',
    'hopeShift',
    'shiftView',
    'personalSetting',
    'recorder',
    'logout',
    '404',
    'monthlyAgreement36',
    'yearlyAgreement36',
    'attendError',
].concat(sessionStorage.getItem('loginUser.companyCode') === 'gmohd' ? ['stampHistory', 'GpsStampHistory'] : []);

export default {};